import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/logged-out/')({
	// Auth0 returns here after clearing the session (this is the allow-listed logout
	// URL). Rather than showing a bare confirmation, send the user straight into the
	// branded login flow.
	beforeLoad: () => {
		throw redirect({ to: '/log-in' });
	},
});
